import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import BuyerDashboard from "./pages/BuyerDashboard";
import Discover from "./pages/Discover";
import VendorProfile from "./pages/VendorProfile";
import RFQManagement from "./pages/RFQManagement";
import Onboarding from "./pages/Onboarding";
import Compliance from "./pages/Compliance";
import Analytics from "./pages/Analytics";
import VendorDashboard from "./pages/VendorDashboard";
import VendorProfileEditor from "./pages/VendorProfileEditor";
import RFQInbox from "./pages/RFQInbox";
import Documents from "./pages/Documents";
import Performance from "./pages/Performance";
import Settings from "./pages/Settings";
import NotFound from "./pages/NotFound";
import { Toaster } from "./components/ui/sonner";
import ErrorBoundary from "./components/ErrorBoundary";
import { Loader2 } from "lucide-react";

function RoleRouter() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#FAFAFA]">
        <Loader2 className="w-6 h-6 animate-spin text-[#6366F1]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "vendor" ? "/vendor-dashboard" : "/dashboard"} replace />;
}

function App() {
  return (
    <ErrorBoundary>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<RoleRouter />} />

          <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            {/* Buyer */}
            <Route path="/dashboard" element={<ProtectedRoute role="buyer"><BuyerDashboard /></ProtectedRoute>} />
            <Route path="/discover" element={<ProtectedRoute role="buyer"><Discover /></ProtectedRoute>} />
            <Route path="/vendor/:id" element={<VendorProfile />} />
            <Route path="/rfq" element={<ProtectedRoute role="buyer"><RFQManagement /></ProtectedRoute>} />
            <Route path="/onboarding" element={<ProtectedRoute role="buyer"><Onboarding /></ProtectedRoute>} />
            <Route path="/compliance" element={<ProtectedRoute role="buyer"><Compliance /></ProtectedRoute>} />
            <Route path="/analytics" element={<ProtectedRoute role="buyer"><Analytics /></ProtectedRoute>} />

            {/* Vendor */}
            <Route path="/vendor-dashboard" element={<ProtectedRoute role="vendor"><VendorDashboard /></ProtectedRoute>} />
            <Route path="/profile/edit" element={<ProtectedRoute role="vendor"><VendorProfileEditor /></ProtectedRoute>} />
            <Route path="/rfq/inbox" element={<ProtectedRoute role="vendor"><RFQInbox /></ProtectedRoute>} />
            <Route path="/documents" element={<ProtectedRoute role="vendor"><Documents /></ProtectedRoute>} />
            <Route path="/performance" element={<ProtectedRoute role="vendor"><Performance /></ProtectedRoute>} />

            {/* Shared */}
            <Route path="/settings" element={<Settings />} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
